<template>
  <v-layout justify-center pt-2>
    <v-flex pt-2>
      <v-container class="formWidth">
        <v-card>
          <v-card-title class="headline">Credits</v-card-title>
          <v-card-text>
            <v-flex v-if="hasCreditY" xs6 pb-4>
              <p>credits annuel: {{ credits.year }}</p>
            </v-flex>
            <v-flex v-else xs6 pb-4>
              <p>no credit annuel</p>
            </v-flex>
            <v-flex v-if="hasCreditD" xs6 pb-4>
              <p>credits à la journée: {{ credits.day }}</p>
            </v-flex>
            <v-flex v-else xs6 pb-4>
              <p>no credit journée</p>
            </v-flex>

            <v-btn @click="openCreditDialog" color="primary">
              {{ $tc('credits.buy') }}
            </v-btn>
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-card>
      </v-container>
    </v-flex>

    <credit-dialog
      v-if="isCreditDialogOpen"
      :type="typeTextDialog"
      :isTextDialogOpen="isCreditDialogOpen"
      :title="textDialogInformations[typeTextDialog].title"
      :explanation="textDialogInformations[typeTextDialog].explanation"
      :details="textDialogInformations[typeTextDialog].details"
      :cancelButtonText="textDialogInformations[typeTextDialog].cancel"
      :confirmButtonText="textDialogInformations[typeTextDialog].confirm"
      @confirm="closeCreditDialog()"
      @close-text-dialog="closeCreditDialog()"
      @cancel="closeCreditDialog()"
    >
    </credit-dialog>
  </v-layout>
</template>

<script>
import CreditDialog from './CreditDialog.vue';

export default {
  name: 'CreditForm',
  components: { CreditDialog },
  data() {
    return {
      isCreditDialogOpen: false,
      typeTextDialog: '',
    };
  },
  created() {},
  computed: {
    currentAccount() {
      return this.$store.getters['accounts/currentAccount'];
    },
    locale() {
      return this.$i18n.locale;
    },
    credits() {
      return this.currentAccount.credits || { year: 0, day: 0 };
    },
    hasCreditD() {
      return this.credits.day > 0;
    },
    hasCreditY() {
      return this.credits.year > 0;
    },
    hasCredit() {
      return this.hasCreditD || this.hasCreditY;
    },
    textDialogInformations() {
      return {
        buyCredit: {
          title: this.$t('credits.dialog.title'),
          explanation: this.$t('credits.dialog.explanation'),
          details: this.$t('credits.dialog.details'),
          confirm: this.$t('credits.dialog.confirmButtonText'),
          cancel: this.$t('credits.dialog.cancelButtonText'),
          confirmButtonColor: 'primary',
        },
      };
    },
  },
  methods: {
    openCreditDialog() {
      this.typeTextDialog = 'buyCredit';
      this.isCreditDialogOpen = true;
    },
    closeCreditDialog() {
      this.isCreditDialogOpen = false;
      this.typeTextDialog = null;
      this.isTextDialogOpen = false;
    },
  },
};
</script>

<style scoped lang="sass">

.formWidth
  width: 800px
</style>
